import { render, staticRenderFns } from "./shopInfo.vue?vue&type=template&id=55acff62&scoped=true&"
import script from "./shopInfo.vue?vue&type=script&lang=js&"
export * from "./shopInfo.vue?vue&type=script&lang=js&"
import style0 from "./shopInfo.vue?vue&type=style&index=0&id=55acff62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55acff62",
  null
  
)

export default component.exports